// import { swal } from 'sweetalert2';
// import { UserCreation } from './../../shared/user-creation.model';
import { UserCreationService } from '../../shared/user-creation.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
// import swal from 'sweetalert2';
import { Search } from './../../shared/user-creation.model';
// import { ErrorHandler } from '../../../shared/ErrorHandler';

@Component({
  selector: 'app-area-creation-grid',
  templateUrl: './area-creation-grid.component.html',
  styleUrls: ['./area-creation-grid.component.css']
})
export class AreaCreationGridComponent implements OnInit {
title="Area List"
  s: any={};
  itemsPerPage: number = 5;
  currentPage: number = 1;
  totalItems: number;
  areaList;
  isSearch: boolean;
  constructor(private userCreationService: UserCreationService,private route: ActivatedRoute) {}

  ngOnInit() {
    this.GetAllAreas(this.itemsPerPage, 1);
  }

  pageChanged(pageNumber: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNumber);
    else
      this.GetAllAreas(this.itemsPerPage, pageNumber);
  }

  itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
    if (this.isSearch)
      this.onSearch(this.s, this.itemsPerPage, pageNo);
    else
      this.GetAllAreas(this.itemsPerPage, pageNo);
  }

  GetAllAreas(itemsPerPage: number, pageNo: number) {
    this.isSearch = false;
    this.userCreationService.GetAllArea(itemsPerPage, pageNo)
      .subscribe(
        (data: any) => {
          this.areaList = data.AreaGridModel;
          this.totalItems = data.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        }, (error) => {
          // document.getElementById('loader-spinner').style.display = "none";
          // this.errorHandler.HandlerError(error);
        }); 
      }

      

      onSearch(s, itemsPerPage: number, pageNo: number) {
        debugger;
        this.isSearch = true;
        let searchText = this.s.SearchText;
        let searchCriteria = this.s.SearchCriteria;
        if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
        alert("wrong");
          // swal("Warning!", "Please enter the search criteria and search text.", "warning");
        else {
          // document.getElementById('loader-spinner').style.display = "block";
          this.userCreationService.SearchAreas(searchCriteria, searchText, itemsPerPage, pageNo)
          
            .subscribe(
              (data: any) => {
                this.areaList = data.AreaGridModel;
                this.totalItems = data.TotalItemsCount;
                this.currentPage = pageNo;
                // document.getElementById('loader-spinner').style.display = "none";
              }, (error) => {
                // document.getElementById('loader-spinner').style.display = "none";
                //swal('Search Failed.');
                // this.errorHandler.HandlerError(error);
              });
        }
      }
      
}



// WEBPACK FOOTER //
// ./src/app/masters/area-creation-grid/area-creation-grid.component.ts